import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface PopupState {
    hideForever: boolean;
    hideUntil: string | null; // ISO 날짜 문자열
    setHideForever: () => void;
    setHideUntil: (isoDate: string) => void;
    resetHideUntil: () => void;
}

export const usePopupStore = create<PopupState>()(
    persist(
        (set) => ({
            hideForever: false,
            hideUntil: null,
            setHideForever: () => set({ hideForever: true }),
            setHideUntil: (iso: string) => set({ hideUntil: iso }),
            resetHideUntil: () => set({ hideUntil: null }),
        }),
        {
            name: 'vivaclass-update-popup-class', // localStorage 키 다른 팝업 작업시 키이름을 바꿔줘야 합니다.
            partialize: (state: PopupState) => ({
                hideForever: state.hideForever,
                hideUntil: state.hideUntil,
            }),
        }
    )
);
